import { render, staticRenderFns } from "./ImportSelectDress.vue?vue&type=template&id=5a40d897&scoped=true"
import script from "./ImportSelectDress.vue?vue&type=script&lang=js"
export * from "./ImportSelectDress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a40d897",
  null
  
)

export default component.exports